/**
 * @param value {string}
 * @param decimals {number}
 * @return {number}
 */
export default function toNumber(value, decimals = 0) {
  return Number(Number(value).toFixed(decimals))
}
